
"use client"

import { useRef } from "react"
import { motion, useInView } from "framer-motion"
import Link from "next/link"
import Image from "next/image"

import one from "@/public/service/01.png"
import two from "@/public/service/02.png"
import three from "@/public/service/03.png"
import four from "@/public/service/04.png"
import five from "@/public/service/05.png"
import six from "@/public/service/06.png"




export default function ServicesSection() {
  const sectionRef = useRef<HTMLDivElement>(null)
  const isInView = useInView(sectionRef, { once: false, amount: 0.1, margin: "-50px" })

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  }

  return (
    <section
      ref={sectionRef}
      className="py-16 md:py-20 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden"
      id="services"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-dots-pattern opacity-5"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial="visible"
          // animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="text-center mb-10 md:mb-16"
        >


          <motion.h2
            variants={itemVariants}
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4"
          >
            Our Premium Report Design Services
          </motion.h2>

          <motion.p variants={itemVariants} className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            From compliance aligned
            <Link href="https://www.annualesg.com/services/sustainability-report-design"> sustainability reports </Link> to
            highly engaging digital
            flipbooks, we design reports
            to elevate your brand.
          </motion.p>
        </motion.div>



        {/* --------------------- */}

        <section
          className="md:px-28 bg-gradient-tob from-white to-gray-50 relative overflow-hidden space-y-20"
          id="services"
        >

          <div className="container mx-auto px-4 relative z-10">
            <motion.div
              // initial="hidden"
              variants={containerVariants}
              className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
            >
              {/* Left Column - Image */}
              <motion.div variants={itemVariants} className="relative">
                <div className="relative h[500px] rounded-2xl overflow-hidden shadow2xl borde flex items-center justify-center">

                  <Image src={one} alt="01" className="w-full h-full object-cover" width={500} height={500} />

                </div>

              </motion.div>

              {/* Right Column - Content */}
              <motion.div variants={containerVariants} className="space-y-6">

                <motion.h3 variants={itemVariants} className="text-4xl md:text-5xl font-bold text-primary mb-6">
                  <span className="text-gradient">Sustainability Report Design</span>
                </motion.h3>

                <motion.p variants={itemVariants} className="text-lg text-gray-600">
                  Transform complex environmental, social and governance data
                  into compelling visual stories that showcase your commitment
                  to responsible business practices. We map your disclosures to
                  GRI, SASB, and ISSB standards .
                </motion.p>

                <motion.div
                  variants={itemVariants}
                  initial="hidden"
                  animate={isInView ? "visible" : "hidden"}
                  className="text-cente"
                >
                  <Link href="/services/sustainability-report-design" className="bg-gray-800 hover:bg-gray-900 text-white px-6 py-3 md:px-6 md:py-3 text-base md:text-md rounded-full shadow-lg transition-all duration-300 hover:shadow-xl">
                    Explore
                  </Link>
                </motion.div>

              </motion.div>
            </motion.div>
          </div>


          <div className="container mx-auto px-4 relative z-10">
            <motion.div
              // initial="hidden"
              variants={containerVariants}
              className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
            >



              {/* Right Column - Content */}
              <motion.div variants={containerVariants} className="space-y-6 order-2 lg:order-1">

                <motion.h3 variants={itemVariants} className="text-4xl md:text-5xl font-bold text-primary mb-6">
                  <span className="text-gradient">Esg Report Design</span>
                </motion.h3>

                <motion.p variants={itemVariants} className="text-lg text-gray-600">
                  Create transparency-focused reports that meet investor
                  expectations while engaging diverse stakeholder groups with
                  clear, accessible design. Clear charts, materiality matrices,
                  and data storytelling meet CSRD expectations.
                </motion.p>


              </motion.div>



              {/* Left Column - Image */}
              <motion.div variants={itemVariants} className="relative order-1 lg:order-2">
                <div className="relative h[500px] rounded-2xl overflow-hidden shadow2xl borde flex items-center justify-center">

                  {/* <div className="leading-none text-[15rem] font-semibold text-gray-800">04</div> */}

                  <Image src={two} alt="04" className="w-full h-full object-cover" width={500} height={500} />

                  {/* <div className="text-[15rem] font-extrabold leading-none bg-gradient-to-br from-[#39FF14] via[#FFD700] viagray-300 to-[#00FF7F] toblack bg-clip-text text-transparent drop-shadow-[4px_4px_0_rgba(0,0,0,0.25)]">
                    04
                  </div> */}

                </div>

              </motion.div>


            </motion.div>
          </div>


          <div className="container mx-auto px-4 relative z-10">
            <motion.div
              // initial="hidden"
              variants={containerVariants}
              className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
            >
              {/* Left Column - Image */}
              <motion.div variants={itemVariants} className="relative">
                <div className="relative h[500px] rounded-2xl overflow-hidden shadow2xl borde flex items-center justify-center">


                  {/* <div className="leading-none text-[15rem] font-semibold text-gray-800">01</div> */}

                  <Image src={three} alt="01" className="w-full h-full object-cover" width={500} height={500} />

                  {/* <div className="text-[15rem] font-extrabold leading-none bg-gradient-to-br from-[#C28840] via[#FFD700] viagray-300 to-[#FFD700] toblack bg-clip-text text-transparent drop-shadow-[4px_4px_0_rgba(0,0,0,0.25)]">
                    01
                  </div> */}

                </div>

              </motion.div>

              {/* Right Column - Content */}
              <motion.div variants={containerVariants} className="space-y-6">

                <motion.h3 variants={itemVariants} className="text-4xl md:text-5xl font-bold text-primary mb-6">
                  <span className="text-gradient">Integrated Report Design</span>
                </motion.h3>

                <motion.p variants={itemVariants} className="text-lg text-gray-600">
                  Seamlessly blend financial and sustainability data into
                  organized reports that demonstrate your company's holistic
                  value creation approach.
                </motion.p>

                <motion.div
                  variants={itemVariants}
                  initial="hidden"
                  animate={isInView ? "visible" : "hidden"}
                  className="text-cente"
                >
                  <Link href="/services/integrated-report-design" className="bg-gray-800 hover:bg-gray-900 text-white px-6 py-3 md:px-6 md:py-3 text-base md:text-md rounded-full shadow-lg transition-all duration-300 hover:shadow-xl">
                    Explore
                  </Link>
                </motion.div>

              </motion.div>
            </motion.div>
          </div>



          <div className="container mx-auto px-4 relative z-10">
            <motion.div
              // initial="hidden"
              variants={containerVariants}
              className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
            >



              {/* Right Column - Content */}
              <motion.div variants={containerVariants} className="space-y-6 order-2 lg:order-1">

                <motion.h3 variants={itemVariants} className="text-4xl md:text-5xl font-bold text-primary mb-6">
                  <span className="text-gradient">CSR Report Design</span>
                </motion.h3>

                <motion.p variants={itemVariants} className="text-lg text-gray-600">
                  Showcase social impact with narrative depth. Communicate
                  your social impact initiatives through thoughtful design that
                  builds brand credibility and stakeholder trust. Best practices
                  proven to boost reputation.
                </motion.p>


              </motion.div>



              {/* Left Column - Image */}
              <motion.div variants={itemVariants} className="relative order-1 lg:order-2">
                <div className="relative h[500px] rounded-2xl overflow-hidden shadow2xl borde flex items-center justify-center">
                  {/* <div className="leading-none text-[15rem] font-semibold text-gray-800">06</div> */}

                  <Image src={four} alt="06" className="w-full h-full object-cover" width={500} height={500} />

                </div>


              </motion.div>


            </motion.div>
          </div>



          <div className="container mx-auto px-4 relative z-10">
            <motion.div
              // initial="hidden"
              variants={containerVariants}
              className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
            >
              {/* Left Column - Image */}
              <motion.div variants={itemVariants} className="relative">
                <div className="relative h[500px] rounded-2xl overflow-hidden shadow2xl borde flex items-center justify-center">


                  {/* <div className="leading-none text-[15rem] font-semibold text-gray-800">01</div> */}

                  <Image src={five} alt="01" className="w-full h-full object-cover" width={500} height={500} />

                  {/* <div className="text-[15rem] font-extrabold leading-none bg-gradient-to-br from-[#C28840] via[#FFD700] viagray-300 to-[#FFD700] toblack bg-clip-text text-transparent drop-shadow-[4px_4px_0_rgba(0,0,0,0.25)]">
                    01
                  </div> */}

                </div>

              </motion.div>

              {/* Right Column - Content */}
              <motion.div variants={containerVariants} className="space-y-6">

                <motion.h3 variants={itemVariants} className="text-4xl md:text-5xl font-bold text-primary mb-6">
                  <span className="text-gradient">Annual Report Design</span>
                </motion.h3>

                <motion.p variants={itemVariants} className="text-lg text-gray-600">
                  Present your company’s yearly performance with clarity and
                  impact. Team Annual ESG helps you design a well-structured
                  and professional <Link href="https://www.annualesg.com/services/annual-report-design"> Annual Report </Link> that make complex data
                  digestible and engaging for all audiences well-structured.
                </motion.p>

                <motion.div
                  variants={itemVariants}
                  initial="hidden"
                  animate={isInView ? "visible" : "hidden"}
                  className="text-cente"
                >
                  <Link href="/services/annual-report-design" className="bg-gray-800 hover:bg-gray-900 text-white px-6 py-3 md:px-6 md:py-3 text-base md:text-md rounded-full shadow-lg transition-all duration-300 hover:shadow-xl">
                    Explore
                  </Link>
                </motion.div>

              </motion.div>
            </motion.div>
          </div>



          <div className="container mx-auto px-4 relative z-10">
            <motion.div
              // initial="hidden"
              variants={containerVariants}
              className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
            >



              {/* Right Column - Content */}
              <motion.div variants={containerVariants} className="space-y-6 order-2 lg:order-1">

                <motion.h3 variants={itemVariants} className="text-4xl md:text-5xl font-bold text-primary mb-6">
                  <span className="text-gradient">Digital Guides Design</span>
                </motion.h3>

                <motion.p variants={itemVariants} className="text-lg text-gray-600">
                  Dynamic knowledge bites, flipbooks and microsites invite
                  readers to download, read, and share. Engagement rates
                  jump when data becomes an experience.
                </motion.p>


              </motion.div>



              {/* Left Column - Image */}
              <motion.div variants={itemVariants} className="relative order-1 lg:order-2">
                <div className="relative h[500px] rounded-2xl overflow-hidden shadow2xl borde flex items-center justify-center">
                  {/* <div className="leading-none text-[15rem] font-semibold text-gray-800">06</div> */}

                  <Image src={six} alt="06" className="w-full h-full object-cover" width={500} height={500} />

                </div>


              </motion.div>


            </motion.div>
          </div>


        </section>

        {/* --------------------- */}



        <motion.div
          variants={itemVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="mt-10 md:mt-16 text-center"
        >
          <Link href="#contact" className="bg-gray-800 hover:bg-gray-900 text-white px-6 py-3 md:px-8 md:py-4 text-base md:text-lg rounded-full shadow-lg transition-all duration-300 hover:shadow-xl">
            Get a Quote
          </Link>
        </motion.div>
      </div>
    </section>
  )
}
